import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { UtilService } from 'app/shared/util.service';
import { getDetractorsRateQualification, Qualification, NpsResponse } from '../followup-summary-widgets.utils';

@Component({
  selector: 'mh-surveys-summary-detractors-rate',
  templateUrl: './detractors-rate-widget.component.html',
  standalone: false,
})
export class DetractorsRateWidgetComponent implements OnChanges {
  @Input() npsData: NpsResponse;
  @Input() loading = false;
  @Input() productId = 1;

  detractorsRatePercentage = 0;
  detractorsRateCount = '–';
  qualificationDetractorsRate: Qualification = 'no_data';
  heigth = '100%';

  constructor(
    private utilService: UtilService,
    private router: Router,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.npsData) {
      if (this.npsData) {
        this.handleSuccess(this.npsData);
      } else {
        this.handleError();
      }
    }
  }

  get detractorsRateDescription(): string {
    if (this.qualificationDetractorsRate === 'excellent') {
      return 'followup.summary.data-rate.detractors_rate.description_excellent';
    }
    if (this.qualificationDetractorsRate === 'good') {
      return 'followup.summary.data-rate.detractors_rate.description_good';
    }
    return 'followup.summary.data-rate.detractors_rate.description';
  }

  private handleSuccess(response: NpsResponse): void {
    const actual = response.average.detractor_answered_contacted_guest_rate.actual;
    const detractors = response.average.details.actual.detractors || 0;

    if (actual != null && detractors > 0) {
      const percentage = Math.round(actual);
      const contacted = response.average.details.actual.detractor_answered_contacted_guest || 0;

      this.detractorsRatePercentage = percentage;
      this.detractorsRateCount = `${contacted}/${detractors}`;
      this.qualificationDetractorsRate = getDetractorsRateQualification(actual);
    } else {
      this.handleError();
    }
  }

  private handleError(): void {
    this.detractorsRatePercentage = 0;
    this.detractorsRateCount = '–';
    this.qualificationDetractorsRate = 'no_data';
  }

  onViewMore(): void {
    const isFollowup = this.productId === 1;
    const productName = isFollowup ? 'followup' : 'onsite';
    const path = isFollowup ? ['/intercadena/followup/tendencias'] : ['/intercadena/onsite/tendencias'];

    this.utilService.ga('', `interchain-${productName}-detractorsrate-viewdetractors`);
    this.router.navigate(path, { queryParams: { trend: 'detractors' } });
  }
}
